import React from 'react';
import styled, { keyframes } from 'styled-components';
import _ from 'lodash';
import {
  Dropdown,
  Menu,
  Form,
  Input,
  Select,
  Button,
  Carousel,
  Icon,
  Modal,
  Radio,
} from 'antd';
import renderHTML from 'react-render-html';
import ReactGA from 'react-ga';
import Cookies from 'js-cookie';

import 'antd/dist/antd.css';
import '../styles/font/stylesheet.css';
import '../styles/edit-antd.css';
import LogoImg from '../images/logo.png';
import slideImage1 from '../images/slider/___000___Phuket’s-most-desired-residential-community.jpg';
import slideImage2 from '../images/slider/___001___Contemporary-2-5-bedroom-homes-in-Laguna-Phuket.jpg';
import slideImage3 from '../images/slider/___002___A-choice-of-standard-and-deluxe-townhomes-and-villas.jpg';
import slideImage4 from '../images/slider/___003___Spacious-living-area-in-a-gated-environment.jpg';
import slideImage5 from '../images/slider/___004___10-miniutes-from-the-beach.jpg';
import slideImage6 from '../images/slider/___005___Complimentary-membership-to-Laguna-Golf-Phuket.jpg';
import slideImage7 from '../images/slider/___006___Professional-property-management-services.jpg';
import slideImage8 from '../images/slider/___007___Exclusive-privileges-from-Banyan-Tree-Group-worldwide-.jpg';
import slideImage9 from '../images/slider/___008___A-new-beginning.jpg';

import country from '../data/country.json';
import Img5PercenImgEn from '../images/image5percenEn.png';
import Img5PercenImgCn from '../images/image5percenZh.png';

import SendMailData from '../components/SendMailData';
import Reaptcha from '../components/Reaptcha';

require('es6-promise').polyfill();
require('isomorphic-fetch');

const FormItem = Form.Item;
const { TextArea } = Input;
const { Option, OptGroup } = Select;

const LeftBlock = styled.div`
  @media (max-width: 1024px) {
    width: calc(100% - 322px);
  }
  @media (max-width: 768px) {
    width: 100vw;
    flex-shrink: 0;
  }
  overflow: hidden;
  position: relative;
`;
const SliderBlock = styled.div`
  width: 100%;
  height: calc(100vh);
  overflow: hidden;
  position: relative;
  @media (max-width: 1024px) {
    height: calc(100vh);
  }
  @media (max-width: 768px) {
    width: 100vw !important;
    height: 100vw !important;
    flex-shrink: 0;
  }
`;

const Topblock = styled.div`
  width: 100%;
  min-height: 91px;
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  flex: 0 0 auto;

  @media (min-width: 769px) {
    // box-shadow: rgba(0, 0, 0, 0.75) 0px 0px 26px -15px;
    position: absolute;
    z-index: 2;
  }
  @media (max-width: 768px) {
    min-height: 20px;
  }
`;

const TextBlock = styled.div`
  flex: 1 1 auto;
  text-align: center;
  padding: 8px;
`;

const TextSlider = styled.div`
  position: absolute;
  display: flex;
  flex-flow: column;
  transition: left 3s, opacity 3.8s;
  left: ${props => (props.active ? '0' : '-60%')};
  opacity: ${props => (props.active ? '1' : '0')};
  width: 100%;
  bottom: 60px;
  background: rgba(0, 0, 0, 0.3);
  padding: 0 40px;
  @media (max-width: 1024px) {
    padding: 0 32px;
  }
  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

const TextSliderTop = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  @media (max-width: 768px) {
    font-size: 16px;
  }
  @media (min-width: 1500px) {
    font-size: 30px;
  }
`;

const TextSliderBottom = styled.div`
  font-size: 12px;
  font-weight: 500;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const PageSlider = styled.div`
  text-align: center;
  height: calc(100vh);
  background: #364d79;
  background-size: auto 100%;
  background-size: cover;
  background-position: center;
  width: calc(100vw - 354px);
  @media (max-width: 1024px) {
    width: calc(100vw - 322px);
    height: calc(100vh);
  }
  @media (max-width: 768px) {
    width: 100vw !important;
    height: 100vw !important;
    flex-shrink: 0;
  }
`;

const BtnControlSlider = styled.div`
  position: absolute;
  display: flex;
  bottom: 17px;
  right: 26px;
  @media (max-width: 1024px) {
    display: none;
  }
`;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: row nowrap;
  @media (max-width: 768px) {
    flex-flow: column nowrap;
    align-items: center;
    height: auto;
  }
`;

const RegisterBlock = styled.div`
  width: 354px;
  overflow-y: scroll;
  height: 100vh;
  background-color: #719133;
  padding-top: 14px;
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  flex-flow: column nowrap;
  @media (max-width: 1024px) {
    width: 322px;
  }
  @media (max-width: 768px) {
    width: 100%;
    border-top: none;
    height: auto;
  }
`;

const LangBlock = styled.div`
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #333333;
  padding: 0 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 25px;
  @media (max-width: 1024px) {
    margin-bottom: 8px;
  }
  @media (max-width: 768px) {
    display: none;
  }
  @media (min-height: 1200px) {
    margin-bottom: 40px;
  }
`;

const LangBlockMobile = styled(LangBlock)`
  @media (min-width: 769px) {
    display: none;
  }
  @media (max-width: 768px) {
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    margin-bottom: 42px;
    margin-top: 20px;
    position: absolute;
  }
`;

const LangSpan = styled.span`
  cursor: pointer;
  color: ${props => (props.active ? '#fff' : '#fff')};
  opacity: ${props => (props.active ? 1 : 0.3)};
  @media (max-width: 768px) {
    color: ${props => (props.active ? '#719133' : '#333333')};
    font-size: 14px;
    // padding: 4px 8px;
    // background: #719133;
    // box-shadow: 2px 3px 11px -4px rgba(0, 0, 0, 0.75);
  }
`;
const SplitLine = styled.div`
  width: 1px;
  height: 16px;
  opacity: 0.2;
  background-color: #000000;
  margin: 0 12px;
  @media (max-width: 768px) {
    font-size: 20px;
    margin: 0 24px;
  }
`;

const Header = styled.h1`
  font-size: 20px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 0.5px;
  text-align: center;
  margin-bottom: 20px;
  color: #6d6e71;
  &.color-fff {
    color: #fff;
  }

  @media (max-width: 1170px) {
    margin-bottom: 8px;
  }
  @media (max-width: 425px) {
    font-size: 18px;
  }
  @media (min-width: 769px) {
    font-size: 20px;
    text-shadow: none;
    &.nomargin {
      color: #fff;
      font-size: 24px;
      text-shadow: 0px 5px 11px rgba(0, 0, 0, 0.4);
      margin: 1rem 0 0;
    }
  }
`;

const Logo = styled.img`
  width: 200px;
  height: auto;
  object-fit: contain;
  @media (max-width: 768px) {
    display: none;
  }

  @media (min-width: 1500px) {
    width: 260px;
  }
`;
const ShineEffect = keyframes`
  0% {
    background-position: -170px 0;
  }

  50%, 100% {
    background-position: 30px 0;
  }
`;

const Mask = styled.div`
  position: relative;
  display:flex;
  width: 200px;
  height: 87px;
  text-align:center;
  background: ;
  -webkit-filter: drop-shadow(1px 1px 2px rgba(0,0,0,0.1));
  background-position: -170px 0;
  animation: ${ShineEffect} 4s linear infinite;
  margin-left: 16px;
  margin-top: 16px;
  &::after{
    content:'';
    position: absolute;
    pointer-events: none;
    top:0; left:0; right:0; bottom: 0;
    background: radial-gradient(0 0,circle farthest-side, rgba(255,255,255,0) 90%,rgba(255,255,255,.8) 98%,rgba(255,255,255,0) 100%) no-repeat;
    background: radial-gradient(circle farthest-side at 0 0, rgba(255,255,255,0) 90%,rgba(255,255,255,.8) 98%,rgba(255,255,255,0) 100%) no-repeat;
    background-position: inherit; 
    -webkit-mask: url('${LogoImg}') center;
    mask-size: 100% 100%;
  }
  @media (max-width: 768px) {
    display: none;
  }

  @media (min-width: 1500px) {
    width: 260px;
    height: 100px;
  }
`;

const LogoMobile = styled(Logo)`
  width: 172px;
  height: 79px;
  @media (min-width: 769px) {
    display: none;
  }
  @media (max-width: 768px) {
    display: block;
  }
`;

const MaskMobile = styled(Mask)`
  width: 172px;
  height: 79px;
  @media (min-width: 769px) {
    display: none;
  }
  @media (max-width: 768px) {
    display: block;
    margin-bottom: 16px;
  }
`;

const RegisterConetentBlock = styled.div`
  width: 100%;
  padding: 0 24px;
  display: flex;
  flex-flow: column nowrap;
  .ant-form {
    padding: 16px;
    background: #fff;
    margin-bottom: 16px;
  }
  @media (max-width: 1024px) {
    padding: 0 24px;
  }
`;
const Block50Left = styled.div`
  width: 50%;
  padding-right: 3px;
`;
const Block50Right = styled.div`
  width: 50%;
  padding-left: 3px;
`;
const BlockDue = styled.div`
  width: 100%;
  display: flex;
`;

const AppointmentPreferen = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #505a5a;
  margin: 12px 0;
  display: inline-block;
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;
const LinkBlock = styled.div`
  width: 100%;
  display: flex;
  margin: 6px 0;
  justify-content: center;
  margin-top: ${props => {
    return props.first ? '0' : '6';
  }};
  @media (max-width: 1024px) {
    margin-top: 6px;
  }
`;
const LinkTo = styled.a`
  font-size: 12px;
  text-align: center;
  color: #cccccc;
  display: inline-block;
  padding: 0 8px;
  line-height: 1;
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    color: #555555;
  }
`;
const TextTel = styled.span`
  font-size: 12px;
  text-align: center;
  color: #cccccc;
  display: inline-block;
  padding: 0 8px;
  line-height: 1;
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    color: #555555;
  }
`;

const ButtonShadow = styled.div`
  box-shadow: 0px 0px 11px -4px rgba(0, 0, 0, 0.75);
  padding: 4px 8px;
`;

const dataLang = {
  description: {
    eventName: {
      en: `<span>Visit the showcase of Phuket’s latest residential property and holiday homes
        from Phuket’s biggest and most established developer</span>`,
      cn: '<span>誠邀您參加布吉樂古浪熙園2項目預覽</span>',
      ru:
        '<span>Your exclusive preview of new freehold condominiums in the heart of Laguna Phuket</span>',
      th:
        '<span>Your exclusive preview of new freehold condominiums in the heart of Laguna Phuket</span>',
      hk:
        '<span>歡迎參觀來自布吉最大最成熟的發展商最新住宅和度假屋的展示,</span>',
    },
    date: {
      en: `Sat 9th  - Sun 10th   November 2019<br/>
      Island Shangri La, Pacific Place,<br/>
      Supreme Court Road, Central, Hong Kong<br/>
      Taishan Room, Level 5, 11AM - 6PM
      `,
      // en:
      //   'Sat 17th - Sun 18th August 2019<br/>Hilton Singapore<br/>581 Orchard Rd, Singapore<br/>Thailand & Singapore Room, Level 5, 11 AM – 6 PM',
      cn:
        '2019年8月17日星期六至8月18日星期日<br/>新加坡希尔顿酒店<br/>新加坡乌节路581号<br/>泰国及新加坡厅，5楼，11:00 – 18:00',
      ru:
        'Sat 17th - Sun 18th August 2019<br/>Hilton Singapore<br/>581 Orchard Rd, Singapore<br/>Thailand & Singapore Room, Level 7, 11 AM – 6 PM',
      th:
        'Sat 17th - Sun 18th August 2019<br/>Hilton Singapore<br/>581 Orchard Rd, Singapore<br/>Thailand & Singapore Room, Level 7, 11 AM – 6 PM',
      hk: `星期六,2019年11月9-10日<br/>
      港島香格里拉大酒店,香港 中環 法院道太古廣場<br/>
      5樓泰山廳,開發時間 早上11時正至下午6時正
      `,
    },
    venue: {
      en:
        'Sat 7<sub>th</sub> - Sun 8th September 2019<br/>Island Shangri-La, Hong Kong<br/>Pacific Place, Supreme Ct Rd, Central, Hong Kong<br/>Taishan Room, Level 5, 11 AM – 6 PM',
      cn:
        'Sat 7<sub>th</sub> - Sun 8th September 2019<br/>Island Shangri-La, Hong Kong<br/>Pacific Place, Supreme Ct Rd, Central, Hong Kong<br/>Taishan Room, Level 5, 11 AM – 6 PM',
      ru:
        'Sat 7<sub>th</sub> - Sun 8th September 2019<br/>Island Shangri-La, Hong Kong<br/>Pacific Place, Supreme Ct Rd, Central, Hong Kong<br/>Taishan Room, Level 5, 11 AM – 6 PM',
      th:
        'Sat 7<sub>th</sub> - Sun 8th September 2019<br/>Island Shangri-La, Hong Kong<br/>Pacific Place, Supreme Ct Rd, Central, Hong Kong<br/>Taishan Room, Level 5, 11 AM – 6 PM',
      hk:
        'Sat 7<sub>th</sub> - Sun 8th September 2019<br/>Island Shangri-La, Hong Kong<br/>Pacific Place, Supreme Ct Rd, Central, Hong Kong<br/>Taishan Room, Level 5, 11 AM – 6 PM',
    },
  },
  title: {
    en: 'REGISTER YOUR INTEREST',
    cn: '请登记您的信息',
    ru: 'ЗАРЕГИСТРИРОВАТЬСЯ',
    th: 'ลงทะเบียนเพื่อรับข้อมูลเพิ่มเติม',
    hk: '請輸入你的資料',
  },
  dropDownTitle: {
    en: ['Title *', 'MR.', 'MS.', 'MRS.'],
    cn: ['称谓 *', '先生', '小姐', '女士'],
    ru: ['Обращение *', 'Мистер', 'Мисс', 'Миссис'],
    th: ['คำนำหน้าชื่อ *', 'นาย', 'นางสาว', 'นาง'],
    hk: ['稱呼 *', '先生', '小姐', '女士'],
  },
  firstName: {
    en: 'First name *',
    cn: '名 *',
    ru: 'имя *',
    th: 'ชื่อ *',
    hk: '名字 *',
  },
  lastName: {
    en: 'Last name *',
    cn: '姓 *',
    ru: 'Фамилия *',
    th: 'นามสกุล *',
    hk: '姓氏 *',
  },
  email: {
    en: 'E-mail *',
    cn: '电子邮箱 *',
    ru: 'Адрес электронной почты *',
    th: 'อีเมล *',
    hk: '電郵 *',
  },
  contactNumber: {
    en: 'Contact number',
    cn: '电话',
    ru: 'Телефон',
    th: 'หมายเลขโทรศัพท์',
    hk: '電話',
  },
  Message: {
    en: 'Message',
    cn: '留言',
    ru: 'Ваше Сообщение',
    th: 'ข้อความ',
    hk: '留言',
  },
  Submit: {
    en: 'Submit',
    cn: '提交',
    ru: 'ОТПРАВИТЬ',
    th: 'ส่งข้อมูล',
    hk: '提交',
  },
  exhibitionDates: {
    en: [
      'Date *',
      'Saturday',
      'Sunday',
      'To be confirmed',
      'Will not attend (wish to receive infomation)',
    ],
    cn: [
      '推介会时间 *',
      '星期六',
      '星期日',
      '待定',
      '不参加本次活动 (但希望以后收到相关信息)',
    ],
    ru: [
      'Date *',
      'Saturday',
      'Sunday',
      'To be confirmed',
      'Will not attend (wish to receive infomation)',
    ],
    th: [
      'Date *',
      'Saturday',
      'Sunday',
      'To be confirmed',
      'Will not attend (wish to receive infomation)',
    ],
    hk: ['星期六 *', '星期六', '星期日', '待確認', '不會參加 (希望收到資料)'],
  },
  contactTime: {
    en: [
      'Time *',
      '11.00 - 12.00',
      '12.00 - 13.00 ',
      '13.00 - 14.00 ',
      '14.00 - 15.00 ',
      '15.00 - 16.00 ',
      '16.00 - 17.00 ',
      '17.00 - 18.00',
      'To be confirmed',
      'Will not attend (wish to receive infomation)',
    ],
    cn: [
      '方便联系时间 *',
      '11.00 - 12.00',
      '12.00 - 13.00 ',
      '13.00 - 14.00 ',
      '14.00 - 15.00 ',
      '15.00 - 16.00 ',
      '16.00 - 17.00 ',
      '17.00 - 18.00',
      '待定',
      '不参加本次活动 (但希望以后收到相关信息)',
    ],
    ru: [
      'Time *',
      '11.00 - 12.00',
      '12.00 - 13.00 ',
      '13.00 - 14.00 ',
      '14.00 - 15.00 ',
      '15.00 - 16.00 ',
      '16.00 - 17.00 ',
      '17.00 - 18.00',
      '待定',
    ],
    th: [
      'เวลา *',
      '11.00 - 12.00',
      '12.00 - 13.00 ',
      '13.00 - 14.00 ',
      '14.00 - 15.00 ',
      '15.00 - 16.00 ',
      '16.00 - 17.00 ',
      '17.00 - 18.00',
      '待定',
    ],
    hk: [
      '方便联系时间 *',
      '11.00 - 12.00',
      '12.00 - 13.00 ',
      '13.00 - 14.00 ',
      '14.00 - 15.00 ',
      '15.00 - 16.00 ',
      '16.00 - 17.00 ',
      '17.00 - 18.00',
      '待確認',
      '不會參加 (希望收到資料)',
    ],
  },
  otherQuestion: {
    en: [
      'How did you hear about our event ? * ',
      {
        title: 'Newspapers',
        dropdown: [
          'South China Morning Post',
          'Sing Tao Daily',
          'Sunday – SCMP',
          'Hong Kong Economic Times',
          'Hong Kong Economic Journal',
          'Other',
        ],
      },
      {
        title: 'Email',
        dropdown: [
          'Banyan Tree Group Property',
          'Laguna Property',
          'Ricacorp',
          'Other',
        ],
      },
      {
        title: 'Website',
        dropdown: [
          'Banyan Tree Assciated Sites Web Banne',
          'Social Media',
          'Google Search & Website Banner',
          'Facebook',
          'Other',
        ],
      },
      {
        title: 'Other Sources',
        dropdown: ['Metro Radio HK'],
      },
    ],
    cn: [
      '您如何得知我们的展会 *',
      {
        title: '报纸',
        dropdown: [
          '商业时报',
          '海峡时报',
          '星期日泰晤士报',
          'Hong Kong Economic Times (經濟日報)',
          'Hong Kong Economic Journal (信報)',
          '其他',
        ],
      },
      {
        title: '电子邮件',
        dropdown: ['悦榕轩电邮', '悦榕庄电邮', 'PropNex', '其他'],
      },
      {
        title: '网站',
        dropdown: [
          'Banyan Tree Assciated Sites Web Banner',
          '社交媒体',
          'Google Search & Website Banner',
          'Facebook脸谱网',
          '其他',
        ],
      },
      {
        title: '其他来源',
        dropdown: ['其他来源'],
      },
    ],
    ru: [
      'How did you hear about our event ? * ',
      {
        title: 'Newspapers',
        dropdown: [
          'The Business Times',
          'The Straits Times',
          'The Sunday Times',
        ],
      },
      {
        title: 'Email',
        dropdown: [
          'Email from Banyan Tree Residences / Laguna Property',
          'Email from Banyan Tree Hotels & Resorts',
        ],
      },
      {
        title: 'Website',
        dropdown: [
          'The Strait Times Web Banner',
          'Banyan Tree Associated Sites',
        ],
      },
      {
        title: 'Social Media',
        dropdown: ['Facebook', 'Google Search & Website Banner'],
      },
      {
        title: 'Other Sources',
        dropdown: ['Other'],
      },
    ],
    th: [
      'How did you hear about our event ? * ',
      {
        title: 'Newspapers',
        dropdown: [
          'The Business Times',
          'The Straits Times',
          'The Sunday Times',
        ],
      },
      {
        title: 'Email',
        dropdown: [
          'Email from Banyan Tree Residences / Laguna Property',
          'Email from Banyan Tree Hotels & Resorts',
        ],
      },
      {
        title: 'Website',
        dropdown: [
          'The Strait Times Web Banner',
          'Banyan Tree Associated Sites',
        ],
      },
      {
        title: 'Social Media',
        dropdown: ['Facebook', 'Google Search & Website Banner'],
      },
      {
        title: 'Other Sources',
        dropdown: ['Other'],
      },
    ],
    hk: [
      '你從哪裡知道我們的活動 ? * ',
      {
        title: '報紙',
        dropdown: ['南華早報', '星島日報', '星期日南華早報', '其他'],
      },
      {
        title: '電郵',
        dropdown: ['悅榕莊集團地產', '樂古浪地產', '利嘉閣', '其他'],
      },
      {
        title: '網站',
        dropdown: [
          '悅榕集團相關網站網絡橫幅廣告',
          '社交媒體',
          '谷歌搜索 (Google搜索) 及網絡橫幅廣告',
          'Facebook',
          '其他',
        ],
      },
      {
        title: '其他來源',
        dropdown: ['新城電台'],
      },
    ],
  },
  countryOfResidences: {
    en: 'Country of residence *',
    cn: '常居国 *',
    ru: 'Страна проживания *',
    th: 'ประเทศที่พำนัก *',
    hk: '居住國家 *',
  },
  successHead: {
    en: 'Your message has been successfully sent! ',
    cn: '您的留言已提交成功，非常感谢！',
    ru: 'Ваше сообщение было успешно отправлено.',
    th: 'ข้อความของคุณถูกส่งเป็นที่เรียบร้อยแล้ว! ',
    hk: '',
  },
  successContent: {
    en: 'We will contact you within 48 hours of your message submission. ',
    cn: '我们将在您留言后的48小时内与您联系。',
    ru: 'Мы свяжемся с Вами в течение 48 часов с момента подачи запроса',
    th: 'ทีมงานจะติดต่อกลับไปภายใน 48 ชั่วโมงหลังจากที่ได้รับข้อความ. ',
    hk: '已成功發送您的訊息!我們會在48 小時內聯絡 您。',
  },
  textOnSlide: [
    {
      textTitle: {
        en: 'Phuket’s most desired residential community',
        cn: '',
        ru: '',
        th:
          'เปิดประสบการณ์ใหม่กับ คอนโดมิเนียม freehold แบบสตูดิโอหนึ่งและสองห้องนอน',
        hk: '布吉最受歡迎的頂級住宅區',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage1,
      reward: false,
      backgroundPosition: 'left bottom',
    },
    {
      textTitle: {
        en: 'Contemporary 2-5 bedroom homes in Laguna Phuket',
        cn: '全新现代风格2卧至5卧别墅',
        ru: '',
        th: '',
        hk: '布吉樂古浪的 2-5 房聯排別墅及獨立別墅-布吉樂古浪度假村',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage2,
      backgroundPosition: 'center',
    },
    {
      textTitle: {
        en: 'A choice of standard and deluxe townhomes and villas',
        cn: '可选标准及豪华风格',
        ru: '',
        th: 'ร',
        hk: '可選擇標準和豪華聯排別墅和別墅',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage3,
      backgroundPosition: 'left bottom',
    },
    {
      textTitle: {
        en: 'Spacious living area in a gated environment',
        cn: '全天候安保社区里的宽敞居住环境',
        ru: '',
        th: '',
        hk: '24小時安保居住環境, 寬敞舒適',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage4,
      backgroundPosition: 'right center',
    },
    {
      textTitle: {
        en: 'Close to beach',
        cn: '',
        ru: '',
        th: '',
        hk: '10 分鐘內即達海灘',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage5,
      backgroundPosition: 'center bottom',
    },
    {
      textTitle: {
        en: 'Complimentary membership to Laguna Golf Phuket*',
        cn: '普吉岛乐古浪高尔夫球场免费会员*',
        ru: '',
        th: '',
        hk: '布吉樂古浪高爾夫球俱樂部的免費會籍*',
      },
      textDetail: {
        en: '* Terms and conditions apply',
        cn: '* 适用于相关条款和条件 ',
        hk: '* 受條款及細則約束',
      },
      image: slideImage6,
      backgroundPosition: 'center bottom',
    },
    {
      textTitle: {
        en: 'Professional property management services',
        cn: '由乐古浪提供的专业物业管理服务',
        ru: '',
        th: '',
        hk: '由樂古浪提供專業物業管理服務',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage7,
      backgroundPosition: 'center left',
    },
    {
      textTitle: {
        en: 'Exclusive privileges from Banyan Tree Group worldwide*',
        cn: '悦榕集团全球专属特权*',
        ru: '',
        th: '',
        hk: '全球尊享悅榕莊旗下獨家優惠*',
      },
      textDetail: {
        en: '* Terms and conditions apply',
        cn: '* 适用于相关条款和条件 ',
        hk: '* 受條款及細則約束',
      },
      image: slideImage8,
      backgroundPosition: 'center left',
    },
    {
      textTitle: {
        en: 'A new beginning',
        cn: '新的开始',
        ru: '',
        th: '',
        hk: '從新出發',
      },
      textDetail: {
        en: '',
        cn: '',
      },
      image: slideImage9,
      backgroundPosition: 'center',
    },
  ],
  elForPolicy: {
    textDetail: {
      en:
        'We use cookies on this site to improve your user experience. By continuing to use this site, you are agreeing to our',
      cn:
        '我们在此网站使用了cookies来改善你的用户体验。继续访问网站，表示您同意我们的',
      ru:
        'Мы используем файлы cookie на этом сайте, чтобы улучшить ваш пользовательский интерфейс. Продолжая использовать этот сайт, вы соглашаетесь с нашей',
      th:
        'We use cookies on this site to improve your user experience. By continuing to use this site, you are agreeing to our',
      hk:
        'We use cookies on this site to improve your user experience. By continuing to use this site, you are agreeing to our',
    },
    link: {
      en: 'Privacy Policy',
      cn: '隐私政策。',
      ru: 'Политика Конфиденциальности',
      th: 'นโยบายความเป็นส่วนตัว',
      hk: '私隱政策',
    },
    btn: {
      en: 'I ACCEPT',
      cn: '同意',
      ru: 'ПРИНИМАЮ',
      th: 'I ACCEPT',
      hk: 'I ACCEPT',
    },
  },
  viewFullSite: {
    en: 'View Full Site',
    cn: '阅读完整内容',
    ru: 'полный сайт',
    th: 'เข้าสู่เว็บไซต์หลัก',
    hk: '觀看完整物業全景',
  },
  termOfUse: {
    en: 'Terms of use',
    cn: '使用条款',
    ru: 'Условия Использования',
    th: 'ข้อตกลงและเงื่อนไข',
    hk: '使用條款',
  },
  privacyPolicy: {
    en: 'Privacy Policy',
    cn: '隐私政策',
    ru: 'Политика Конфиденциальности',
    th: 'นโยบายความเป็นส่วนตัว',
    hk: '私隱政策',
  },
  img5Percen: {
    en: Img5PercenImgEn,
    cn: Img5PercenImgCn,
    ru: Img5PercenImgCn,
  },
  required: {
    en: 'This filed is required.',
    cn: '星期日泰晤士报.',
    ru: '*Обязательные для заполнения поля',
    th: 'This filed is required.',
    hk: 'This filed is required.',
  },
  appointmentPreferen: {
    en: 'Appointment preference',
    cn: '推介会预约',
    hk: '預約最方便到訪的時間',
  },
  tel: {
    en: 'Hong Kong Toll Free 800-968-908',
    cn: '新加坡免费电话: 800-852-3990',
  },
  eventLocation: [
    {
      value: 'Singapore Event',
      label: {
        en: 'Singapore Event',
        cn: 'Singapore Event',
        ru: 'Singapore Event',
        th: 'Singapore Event',
        hk: 'Singapore Event',
      },
    },
    {
      value: 'Hong Kong Event',
      label: {
        en: 'Hong Kong Event',
        cn: 'Hong Kong Event',
        ru: 'Hong Kong Event',
        th: 'Hong Kong Event',
        hk: 'Hong Kong Event',
      },
    },
  ],
};

const langNavData = {
  en: {
    order: 1,
    title: 'English',
  },
  // cn: {
  //   order: 2,
  //   title: '中文',
  // },
  hk: {
    order: 3,
    title: '繁體',
  },
  // ru: {
  //   order: 4,
  //   title: 'русский язык',
  // },
  // th: {
  //   order: 5,
  //   title: 'ไทย',
  // },
};

const hasErrors = fieldsError => {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
};

class Main extends React.Component {
  state = {
    currentLang: 'en',
    disabledSubmit: false,
    active: false,
    showPolicy: true,
  }
  componentDidMount() {
    const { pathContext } = this.props;
    const getLang = _.get(pathContext, 'lang', 'en');
    // const googleAnalytic = 'UA-127566126-1';
    // ReactGA.initialize(googleAnalytic);
    // ReactGA.pageview(window.location.pathname + window.location.search);
    // const getLang = this.getParameterByName('lang');
    let lang = 'en';
    if (getLang === 'cn') {
      lang = 'cn';
    } else if (getLang === 'hk') {
      lang = 'hk';
    }
    // else if (getLang === 'ru') {
    //   lang = 'ru';
    // } else if (getLang === 'th') {
    //   lang = 'th';
    // } else

    this.setState({
      currentLang: lang,
    });

    setTimeout(() => {
      this.setState({
        active: true,
      });
    }, 300);

    this.Topblock.addEventListener('onresize', () => {
      console.log('aaa');
    });
    window.onresize = () => {
      this.resizeSlider();
    };
    this.resizeSlider();

    // Modal.success({
    //   title: `${_.get(dataLang, `successHead.${lang}`)}`,
    //   content: `${_.get(dataLang, `successContent.${lang}`)}`,
    //   onOk() {
    //     window.location.reload();
    //   },
    // });
  }

  getParameterByName = (name, url) => {
    let cUrl = url;
    if (!url) {
      cUrl = window.location.href;
    }
    const parameterName = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp(`[?&]${parameterName}(=([^&#]*)|&|#|$)`),
      results = regex.exec(cUrl);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  resizeSlider = () => {
    // this.SliderBlock.style.setProperty(
    //   'height',
    //   `calc(100vh - ${this.Topblock.clientHeight}px)`,
    // );
    // const pageSlider = document.getElementsByClassName('page-slider');
    // _.forEach(pageSlider, el => {
    //   el.style.setProperty(
    //     'height',
    //     `calc(100vh - ${this.Topblock.clientHeight}px)`,
    //   );
    // });
  }

  sendEmail = values => {
    const url = 'https://www.lagunaproperty.com/sendmail/sendEmailTo.php';

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...values,
        subject:
          'Property Exhibition Registration Form – Laguna  Park2 Phuket (Hong Kong)',
        to: 'dos@lagunaproperty.com',
        cc: 'info@lagunaproperty.com,pemisak@lagunaproperty.com,vatanyutab@lagunaproperty.com',
      }),
    })
      .then(res => {
        return res.json();
      })
      .then(res => {
        this.setState({
          disabledSubmit: false,
        });
        if (_.get(res, 'data') === 'success') {
          this.success();
          return true;
        }
        return false;
      });
  }
  gtagReportConversion = url => {
    if (window.gtag) {
      const callback = function () {
        if (typeof url !== 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        send_to: 'AW-720550376/IfM2CJim2qkBEOjzytcC',
        event_callback: callback,
      });
      return false;
    }
  }
  handleSubmit = e => {
    const { currentLang, token } = this.state;
    const { pathContext } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        // const project = _.get(pathContext, 'project', '');
        // const subject = '';
        // const sendEmailValue = {
        //   // eventLocation: _.get(values, 'eventLocation', ''),
        //   title: _.get(values, 'title', ''),
        //   firstName: _.get(values, 'firstName', ''),
        //   lastName: _.get(values, 'lastName', ''),
        //   emailAddress: _.get(values, 'email', ''),
        //   telephoneNumber: _.get(values, 'telephone', ''),
        //   countryOfResidences: _.get(values, 'countryOfResidences', ''),
        //   date: _.get(values, 'exhibitionDates', ''),
        //   time: _.get(values, 'contactTime', ''),
        //   howDoesYouHearAboutOurEvent: _.get(values, 'otherQuestion', ''),
        //   message: _.get(values, 'message', ''),
        //   __subject: subject,
        //   appkey: 'Angsana-Bintan-Register',
        // };
        // // console.log(sendEmailValue);
        // // return true;
        // this.btnSubmit.disabled = true;
        // this.setState({
        //   disabledSubmit: true,
        // });
        // this.gtagReportConversion();
        // this.sendEmail(sendEmailValue);

        const sendEmailValue = SendMailData({
          location: 'Thailand - Phuket',
          title: _.get(values, 'title', ''),
          firstname: _.get(values, 'firstName', ''),
          lastname: _.get(values, 'lastName', ''),
          email: _.get(values, 'email', ''),
          telephone: _.get(values, 'telephone', ''),
          country: _.get(values, 'countryOfResidences', ''),
          interested: 'New sales',
          propertytype: '-',
          message: _.get(values, 'message', ''),
          subscribe: false,
          // source: 'microsite',
          source: _.get(values, 'otherQuestion', '-'),
          websiteKey: 'lp',
          sourceUrl: document.URL,
          language: currentLang,
          recaptcha: token,
          // date: _.get(values, 'exhibitionDates', ''),
          // time: _.get(values, 'contactTime', ''),
          // emailSetting: { to: 'nat@forviz.com' },
        }).then(res => {
          this.btnSubmit.disabled = true;
          this.setState({
            disabledSubmit: true,
          });
          this.gtagReportConversion();
          console.log('res', res);

          if (_.get(res, 'status') === 'success') {
            this.success();
            return true;
          }
          return false;
        });
        console.log('sendEmailValue', sendEmailValue);
      }
    });
  }
  changeLang = changeTo => {
    // const project = '';
    let urlLang = '/en';
    if (changeTo === 'cn') {
      urlLang = '/cn';
    } else if (changeTo === 'hk') {
      urlLang = '/hk';
    }
    // else if (changeTo === 'ru') {
    //   urlLang = '/ru';
    // } else if (changeTo === 'th') {
    //   urlLang = '/th';
    // } else
    // dev
    // const { history: { push } } = this.props;
    // push(urlLang);

    // production
    window.location = `https://www.lagunaproperty.com/lagunapark2/exhibition${urlLang}`;
    // window.location = `http://localhost:8000${urlLang}`;
    // window.location = `https://amazing-turing-11849a.netlify.com${urlLang}`;
  }
  prevSlide = () => {
    this.slider.prev();
  }
  nextSlide = () => {
    this.slider.next();
  }
  success() {
    const { currentLang } = this.state;
    const modalMessage = Modal.success({
      title: `${_.get(dataLang, `successHead.${currentLang}`)}`,
      content: `${_.get(dataLang, `successContent.${currentLang}`)}`,
      onOk() {
        window.location.reload();
      },
    });
    setTimeout(() => {
      window.location.reload();
      modalMessage.destroy();
    }, 6000);
  }
  handleHidePolicy = () => {
    Cookies.set('acceptCoockie', 'true');
    this.setState({
      showPolicy: false,
    });
  }
  handleMenuClick = e => {
    this.changeLang(_.get(e, 'key', 'en'));
  }
  handleRecaptchaCallback = (value) => {
    this.setState({
      token: value,
    });
  }
  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { currentLang, active, showPolicy } = this.state;
    // Only show error after a field is touched.
    const orderLangNavData = _.chain(langNavData)
      .map((o, key) => ({
        ...o,
        id: key,
      }))
      .sortBy(['order'])
      .value();
    const menu = (
      <Menu onClick={this.handleMenuClick}>
        {_.map(orderLangNavData, o => {
          return <Menu.Item key={`${o.id}`}>{o.title}</Menu.Item>;
        })}
      </Menu>
    );

    return (
      <Container>
        <LangBlockMobile>
          <Dropdown overlay={menu}>
            <LangSpan active>
              {_.get(langNavData, [currentLang, 'title'], 'select lang')}
              <Icon type="down" style={{ marginLeft: '4px' }} />
            </LangSpan>
          </Dropdown>
        </LangBlockMobile>
        <MaskMobile>
          <LogoMobile src={LogoImg} />
        </MaskMobile>
        <LeftBlock>
          <Topblock
            innerRef={el => {
              this.Topblock = el;
            }}
          >
            <Mask>
              <Logo src={LogoImg} />
            </Mask>
            <TextBlock>
              <Header
                className="nomargin"
                nomargin
                dangerouslySetInnerHTML={{
                  __html: _.get(
                    dataLang,
                    `description.eventName.${currentLang}`,
                    '',
                  ),
                }}
              />
              <BlockHead>
                <div>
                  <p
                    style={{ margin: 0 }}
                    dangerouslySetInnerHTML={{
                      __html: _.get(
                        dataLang,
                        `description.date.${currentLang}`,
                        '',
                      ),
                    }}
                  />
                </div>
                {/* <CenterLine />
                <div>
                  <p
                    style={{ margin: 0 }}
                    dangerouslySetInnerHTML={{
                      __html: _.get(
                        dataLang,
                        `description.veenu.${currentLang}`,
                        '',
                      ),
                    }}
                  />
                </div> */}
              </BlockHead>
            </TextBlock>
          </Topblock>
          <SliderBlock
            innerRef={el => {
              this.SliderBlock = el;
            }}
          >
            <Carousel
              effect="fade"
              speed={3000}
              autoplaySpeed={5000}
              autoplay
              ref={slider => {
                this.slider = slider;
              }}
            >
              {_.map(_.get(dataLang, 'textOnSlide', []), (sliderData, key) => {
                return (
                  <div key={key}>
                    <PageSlider
                      className="page-slider"
                      style={{
                        backgroundImage: `url(${sliderData.image})`,
                        backgroundPosition: _.get(
                          sliderData,
                          'backgroundPosition',
                          '0% 0%',
                        ),
                        // backgroundPosition: 'top right',
                      }}
                    />
                    <TextSlider active={active}>
                      <TextSliderTop>
                        {_.get(sliderData, `textTitle.${currentLang}`, '')}
                      </TextSliderTop>
                      <TextSliderBottom>
                        {_.get(sliderData, `textDetail.${currentLang}`, '')}
                      </TextSliderBottom>
                    </TextSlider>
                    {_.get(sliderData, 'reward') && (
                      <Img5Percen
                        src={_.get(dataLang, `img5Percen.${currentLang}`, '')}
                      />
                    )}
                  </div>
                );
              })}
            </Carousel>
            <BtnControlSlider>
              <div onClick={this.prevSlide}>
                <Icon type="left-square" style={{ fontSize: 36 }} />
              </div>
              <div onClick={this.nextSlide}>
                <Icon type="right-square" style={{ fontSize: 36 }} />
              </div>
            </BtnControlSlider>
          </SliderBlock>
        </LeftBlock>
        <RegisterBlock>
          <LangBlock boxShadow>
            <Dropdown overlay={menu}>
              <LangSpan active>
                <ButtonShadow>
                  {_.get(langNavData, [currentLang, 'title'], 'select lang')}
                  <Icon type="down" style={{ marginLeft: '4px' }} />
                </ButtonShadow>
              </LangSpan>
            </Dropdown>
          </LangBlock>
          <Header className="color-fff">
            {_.get(dataLang, `title.${currentLang}`)}
          </Header>
          <RegisterConetentBlock>
            <Form
              layout="inline"
              onSubmit={this.handleSubmit}
              style={{ flexShrink: 0 }}
            >
              {/* <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('eventLocation', {
                  rules: [
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                      // message: 'Please input your Title!'
                    },
                  ],
                })(
                  <Radio.Group>
                    {_.map(_.get(dataLang, 'eventLocation', []), o => {
                      return (
                        <Radio value={`${o.value}`}>
                          {_.get(o, ['label', currentLang])}
                        </Radio>
                      );
                    })}
                  </Radio.Group>,
                )}
              </FormItem> */}
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('title', {
                  rules: [
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                      // message: 'Please input your Title!'
                    },
                  ],
                })(
                  <Select
                    placeholder={_.get(
                      dataLang,
                      `dropDownTitle.${currentLang}.0`,
                      '',
                    )}
                  >
                    {_.map(
                      _.get(dataLang, `dropDownTitle.${currentLang}`, []),
                      (value, key) => {
                        if (key === 0) {
                          return null;
                        }
                        return (
                          <Option
                            key={key}
                            value={_.get(
                              dataLang,
                              ['dropDownTitle', 'en', key],
                              '',
                            )}
                          >
                            {value}
                          </Option>
                        );
                      },
                    )}
                  </Select>,
                )}
              </FormItem>
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('firstName', {
                  rules: [
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                      // message: 'Please input your First name!'
                    },
                  ],
                })(
                  <Input
                    placeholder={_.get(dataLang, `firstName.${currentLang}`)}
                  />,
                )}
              </FormItem>
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('lastName', {
                  rules: [
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                      // message: 'Please input your Last name!'
                    },
                  ],
                })(
                  <Input
                    placeholder={_.get(dataLang, `lastName.${currentLang}`)}
                  />,
                )}
              </FormItem>
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('email', {
                  rules: [
                    {
                      type: 'email',
                      // message: 'The input is not valid Email address!',
                    },
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                      // message: 'Please input your Email address!',
                    },
                  ],
                })(
                  <Input
                    placeholder={_.get(dataLang, `email.${currentLang}`)}
                  />,
                )}
              </FormItem>
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('telephone', {})(
                  <Input
                    placeholder={_.get(
                      dataLang,
                      `contactNumber.${currentLang}`,
                    )}
                  />,
                )}
              </FormItem>
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('countryOfResidences', {
                  rules: [
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                      // message: 'Please input your Country of residences!'
                    },
                  ],
                })(
                  <Select
                    showSearch
                    placeholder={_.get(
                      dataLang,
                      `countryOfResidences.${currentLang}`,
                    )}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {_.map(
                      _.get(country, 'countries.country', []),
                      (value, key) => {
                        return (
                          <Option
                            key={key}
                            value={_.get(value, 'countryName', '')}
                          >
                            {_.get(value, 'countryName', '')}
                          </Option>
                        );
                      },
                    )}
                  </Select>,
                )}
              </FormItem>
              <AppointmentPreferen>
                {_.get(dataLang, `appointmentPreferen.${currentLang}`, '')}
              </AppointmentPreferen>
              <BlockDue className="input">
                <Block50Left>
                  <FormItem className="input" style={{ width: '100%' }}>
                    {getFieldDecorator('exhibitionDates', {
                      rules: [
                        {
                          required: true,
                          message: _.get(
                            dataLang,
                            `required.${currentLang}`,
                            '',
                          ),
                          // message: _.get(dataLang, `required.${currentLang}`, '')
                        },
                      ],
                    })(
                      <Select
                        dropdownMatchSelectWidth={false}
                        placeholder={_.get(
                          dataLang,
                          `exhibitionDates.${currentLang}.0`,
                          '',
                        )}
                      >
                        {_.map(
                          _.get(dataLang, `exhibitionDates.${currentLang}`, []),
                          (value, key) => {
                            if (key === 0) {
                              return null;
                            }
                            return (
                              <Option
                                key={key}
                                value={_.get(
                                  dataLang,
                                  ['exhibitionDates', 'en', key],
                                  '',
                                )}
                              >
                                {renderHTML(value)}
                              </Option>
                            );
                          },
                        )}
                      </Select>,
                    )}
                  </FormItem>
                </Block50Left>
                <Block50Right>
                  <FormItem className="input" style={{ width: '100%' }}>
                    {getFieldDecorator('contactTime', {
                      rules: [
                        {
                          required: true,
                          message: _.get(
                            dataLang,
                            `required.${currentLang}`,
                            '',
                          ),
                        },
                      ],
                    })(
                      <Select
                        dropdownMatchSelectWidth={false}
                        placeholder={_.get(
                          dataLang,
                          `contactTime.${currentLang}.0`,
                          '',
                        )}
                      >
                        {_.map(
                          _.get(dataLang, `contactTime.${currentLang}`, []),
                          (value, key) => {
                            if (key === 0) {
                              return null;
                            }
                            return (
                              <Option
                                key={key}
                                value={_.get(
                                  dataLang,
                                  ['contactTime', 'en', key],
                                  '',
                                )}
                              >
                                {value}
                              </Option>
                            );
                          },
                        )}
                      </Select>,
                    )}
                  </FormItem>
                </Block50Right>
              </BlockDue>
              <FormItem
                className="input otherQuestion"
                style={{ width: '100%' }}
              >
                {getFieldDecorator('otherQuestion', {
                  rules: [
                    {
                      required: true,
                      message: _.get(dataLang, `required.${currentLang}`, ''),
                    },
                  ],
                })(
                  <Select
                    placeholder={_.get(
                      dataLang,
                      `otherQuestion.${currentLang}.0`,
                      '',
                    )}
                  >
                    {_.map(
                      _.get(dataLang, `otherQuestion.${currentLang}`, []),
                      (value, key) => {
                        if (key === 0) {
                          return null;
                        }
                        return (
                          <OptGroup key={key} label={value.title}>
                            {_.map(
                              _.get(value, 'dropdown', []),
                              (valueDropdown, keyDropdown) => {
                                return (
                                  <Option
                                    key={`${key}-${keyDropdown}`}
                                    value={_.get(
                                      dataLang,
                                      [
                                        'otherQuestion',
                                        'en',
                                        key,
                                        'dropdown',
                                        keyDropdown,
                                      ],
                                      '',
                                    )}
                                  >
                                    {valueDropdown}
                                  </Option>
                                );
                              },
                            )}
                          </OptGroup>
                        );
                      },
                    )}
                  </Select>,
                )}
              </FormItem>
              <FormItem className="input" style={{ width: '100%' }}>
                {getFieldDecorator('message', {})(
                  <TextArea
                    rows={4}
                    placeholder={_.get(dataLang, `Message.${currentLang}`, '')}
                  />,
                )}
              </FormItem>
              <div className="reaptcha-input-block">
                <Reaptcha
                  // render="explicit"
                  render="automatic"
                  size="compact"
                  theme="light"
                  lang={currentLang}
                  callback={this.handleRecaptchaCallback}
                />
              </div>
              <FormItem className="input" style={{ width: '100%' }}>
                <Button
                  type="primary-custom"
                  htmlType="submit"
                  disabled={
                    this.state.disabledSubmit || hasErrors(getFieldsError())
                  }
                  ref={ref => {
                    this.btnSubmit = ref;
                  }}
                >
                  {_.get(dataLang, `Submit.${currentLang}`, '')}
                </Button>
              </FormItem>
              <LinkBlock first>
                <LinkTo
                  target="_blank"
                  href="https://lagunaproperty.com/en/terms"
                  style={{ borderRight: '1px solid #cccccc' }}
                >
                  {_.get(dataLang, `termOfUse.${currentLang}`, '')}
                </LinkTo>
                <LinkTo
                  target="_blank"
                  href="https://lagunaproperty.com/en/privacy-policy"
                >
                  {_.get(dataLang, `privacyPolicy.${currentLang}`, '')}
                </LinkTo>
              </LinkBlock>
              {/* <LinkBlock
                style={{ width: 'calc(100% + 50px)', marginLeft: '-25px' }}
              >
                <LinkTo target="_blank" href="https://www.lagunaproperty.com/">
                  {_.get(dataLang, `viewFullSite.${currentLang}`, '')}
                </LinkTo>
              </LinkBlock> */}
              <LinkBlock
                style={{ width: 'calc(100% + 50px)', marginLeft: '-25px' }}
              >
                <TextTel target="_blank" href="https://www.lagunaproperty.com/">
                  {_.get(dataLang, `tel.${currentLang}`, '')}
                </TextTel>
              </LinkBlock>
            </Form>
          </RegisterConetentBlock>
        </RegisterBlock>
        {Cookies.get('acceptCoockie') !== 'true' && (
          <Policy showPolicy={showPolicy}>
            <div>
              {_.get(dataLang, `elForPolicy.textDetail.${currentLang}`, '')}
              <LinkToPolicy
                target="_blank"
                href="https://lagunaproperty.com/en/privacy-policy"
              >
                {_.get(dataLang, `elForPolicy.link.${currentLang}`, '')}
              </LinkToPolicy>
            </div>
            <Button
              type="primary-custom"
              style={{ width: 'auto', margin: 0 }}
              onClick={this.handleHidePolicy}
            >
              {_.get(dataLang, `elForPolicy.btn.${currentLang}`, '')}
            </Button>
          </Policy>
        )}
      </Container>
    );
  }
}
const WrappedHorizontalLoginForm = Form.create()(Main);
export default WrappedHorizontalLoginForm;

const Policy = styled.div`
  background: rgba(0, 0, 0, 0.8);
  padding: 8px 16px;
  position: fixed;
  width: 100%;
  bottom: 0;
  color: #fff;
  display: ${props => {
    return props.showPolicy ? 'flex' : 'none';
  }};
  align-items: center;
  justify-content: space-between;
`;

const LinkToPolicy = styled.a`
  font-size: 12px;
  text-align: center;
  color: #fff;
  padding: 8px 0;
  line-height: 1;
  display: inline-block;
  border-bottom: 1px solid #fff;
  margin-left: 8px;
  transition: all 0.3s;
  &:hover,
  &:active,
  &:focus {
    border-bottom: 1px solid #555555;
    text-decoration: none;
    color: #555555;
  }
  @media (max-width: 375px) {
    margin-left: 0;
  }
`;

const Img5Percen = styled.img`
  position: absolute;
  z-index: 10;
  top: 20px;
  right: 20px;
  width: 200px;
  @media (max-width: 425px) {
    width: 80px;
  }
`;

const CenterLine = styled.div`
  box-shadow: 0px 5px 11px rgba(0, 0, 0, 0.4);
  width: 2px;
  background: rgb(255, 255, 255);
  flex: 0 0 auto !important;
`;

const BlockHead = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  padding: 8px 16px;
  margin-top: 1rem;
  font-size: 18px;

  @media (max-width: 1170px) {
    font-size: 16px;
  }
  @media (max-width: 425px) {
    font-size: 14px;
  }

  div {
    flex: 1 1 calc(50% - 1px);
    display: flex;
    justify-content: center;
    p {
      display: block;
      text-align: left;
      padding: 0 16px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      @media (max-width: 768px) {
        color: #6d6e71;
      }
      @media (min-width: 769px) {
        text-shadow: 0px 0px 11px rgba(0, 0, 0, 0.8);
      }
    }
    &:first-child {
      p {
        font-weight: bold;
      }
    }
  }

  @media (max-width: 1170px) {
    flex-flow: column;
    padding: 0;
    div {
      flex: 1 0 100%;
      display: flex;
      justify-content: center;
      p {
        text-align: center;
        padding: 4px 8px;
      }
      &:first-child {
        justify-content: center;
        p {
          border-right: none;
          font-weight: bold;
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/main.js